import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ClienteAppRoutingModule } from "./cliente.app-routing.module";

@NgModule({
    imports: [
        CommonModule,
        ClienteAppRoutingModule
    ]
})
export class ClienteAppModule { }
